import React, { useState } from "react";
import {
  Alert,
  Box,
  // CircularProgress,
  Container,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { postNotification } from "../../../../components/utilities/Notifications";
import ListResponsive from "../../../../components/other/ListResponsive";

import CountdownTimer from "../../../../components/utilities/CountdownTimer";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import TimerDisplaySelector from "../SubComponents/TimerDisplaySelector";

import moment from "moment-timezone";
import ArmyListComponent from "../ArmyListComponent";
import TopCutModal from "../TopCutModal";
import {
  BetweenRoundsModal,
  CreatePairingModal,
  EndEventModal,
  PairingModal,
  ProgressModal,
  RoundTimerModal,
  SwapPlayersModal,
  SwapSeatedTableModal,
  SwapSeatNumberModal,
  SwapTableModal,
  SwapTeamPlayersModal
} from "../SubComponents/EventPairingModals";
import {
  FiltersMenu,
  OptionsMenu,
  PairingOptionsMenu,
  PairingPopUpOptionsMenu,
  SeatedPairingOptionsMenu,
  TeamPairingOptionsMenu
} from "../SubComponents/EventPairingsMenus";
import {
  AdepticonTeamRow,
  DoublesRow,
  PlayerRow,
  SeatedRow,
  TeamRow
} from "../SubComponents/EventPairingRows";
import { tabIndexes } from "../../EventOrganize";
import {
  BCPAngleDown,
  BCPAngleLeft,
  BCPAngleRight,
  BCPFilter,
  BCPFilterSlash
} from "../../../../components/icons/bcp/BCPIcons";
import { postData } from "../../../../components/utilities/UtilityFunctions";
import EventPairingsOverview from "../SubComponents/EventPairingsOverview";
import WebSocketIndicator from "../SubComponents/WebSocketIndicator";
import { getCurrentRound } from "../EventPairings";

export default function EventPairingsDefault(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });
  const { t: tArmyList } = useTranslation("translation", {
    keyPrefix: "components.ArmyListComponent"
  });

  const {
    handleTabChange,
    event,
    setEvent,
    organize,
    authContext,
    setResetModalOpen,
    roundNo,
    timerData,
    setTimerData,
    loading,
    subLoading,
    setLoading,
    pairings,
    teamPairings,
    seatedPairings,
    setEndEventModal,
    setPairingProgress,
    setPairingStatus,
    changeRound,
    handlePairingStatus,
    optionsAnchorEl,
    setOptionsAnchorEl,
    setCreatePairingModal,
    setTeamPairing,
    setTeamPlayer,
    setPairing,
    setPairingPopUp,
    setPlayer,
    player,
    setSeatedPairing,
    setOptionsAnchorEl2,
    setOptionsAnchorEl4,
    setOptionsAnchorEl5,
    setOptionsAnchorEl6,
    postSoftScoreSubmit,
    setRoundTimerOptions,
    pairing,
    setTopCutOptions,
    setRefreshPairings,
    optionsAnchorEl2,
    optionsAnchorEl4,
    optionsAnchorEl5,
    optionsAnchorEl6,
    setArmyModalOpen,
    setSwapPlayerModal,
    teamPairing,
    teamPlayer,
    seatedPairing,
    setSwapSeatNumberModal,
    setSwapSeatedPairingModal,
    setSwapTeamModal,
    pairingPopUp,
    setSwapTableModal,
    roundTimerOptions,
    topCutOptions,
    setTriggerHandlePairingStatus,
    endEventModal,
    armyModalOpen,
    swapPlayerModal,
    players,
    teamPlayers,
    swapTeamModal,
    swapSeatNumberModal,
    swapSeatedPairingModal,
    swapTableModal,
    pairingProgress,
    pairingStatus,
    createPairingModal,
    filtersAnchorEl,
    setFiltersAnchorEl,
    filteredPairings,
    filterType,
    setFilterType,
    setSubLoading,
    handleClick,
    _roundNo,
    useWebSockets,
    placingsReady,
    socketStatus,
    handleWSConnection,
    handlePairings,
    setRoundUpdating,
    betweenRoundsModal,
    setBetweenRoundsModal
  } = props;

  const [timerDisplayMode, setTimerDisplayMode] = useState("split");
  const [timerModalTrigger, setTimerModalTrigger] = useState(0);

  const mapFunction = (row, index) => {
    if (!organize && event?.adepticonTeamEvent) {
      return (
        <AdepticonTeamRow
          organize={organize}
          row={row}
          setTeamPairing={setTeamPairing}
          setTeamPlayer={setTeamPlayer}
          setPairing={setPairing}
          setPairingPopUp={setPairingPopUp}
          setPlayer={setPlayer}
          setOptionsAnchorEl2={setOptionsAnchorEl2}
          setOptionsAnchorEl5={setOptionsAnchorEl5}
          event={event}
          authContext={authContext}
          postSoftScoreSubmit={postSoftScoreSubmit}
        />
      );
    } else if (row?.pairingType === "SeatedPairing") {
      return (
        <SeatedRow
          organize={organize}
          row={row}
          setPairing={setSeatedPairing}
          setPairingPopUp={setPairingPopUp}
          setPlayer={setPlayer}
          setOptionsAnchorEl6={setOptionsAnchorEl6}
          postSoftScoreSubmit={postSoftScoreSubmit}
        />
      );
    } else if (event?.doublesEvent || event?.format?.doublesEvent) {
      return (
        <DoublesRow
          organize={organize}
          row={row}
          event={event}
          setTeamPairing={setTeamPairing}
          setTeamPlayer={setTeamPlayer}
          setPairingPopUp={setPairingPopUp}
          setOptionsAnchorEl5={setOptionsAnchorEl5}
          postSoftScoreSubmit={postSoftScoreSubmit}
        />
      );
    } else if (event?.teamEvent || event?.format?.teamEvent) {
      return (
        <TeamRow
          organize={organize}
          row={row}
          setTeamPairing={setTeamPairing}
          setTeamPlayer={setTeamPlayer}
          setPairing={setPairing}
          setPairingPopUp={setPairingPopUp}
          setPlayer={setPlayer}
          setOptionsAnchorEl2={setOptionsAnchorEl2}
          setOptionsAnchorEl5={setOptionsAnchorEl5}
          event={event}
          postSoftScoreSubmit={postSoftScoreSubmit}
        />
      );
    } else {
      return (
        <PlayerRow
          organize={organize}
          row={row}
          setPairing={setPairing}
          setPairingPopUp={setPairingPopUp}
          setPlayer={setPlayer}
          setOptionsAnchorEl2={setOptionsAnchorEl2}
          event={event}
          postSoftScoreSubmit={postSoftScoreSubmit}
          key={index}
        />
      );
    }
  };

  const generatePairings = async () => {
    if (betweenRoundsModal) setBetweenRoundsModal(false);

    setPairingProgress(5);
    setPairingStatus("pending_generate");
    try {
      if (event?.format?.leagueEvent) {
        await postData(`/events/${event.id}/setCurrentRound`, {
          body: {
            round: (roundNo || 0) + 1
          }
        });
        setPairingProgress(100);
        setPairingStatus(null);
        postNotification("success", t("nextRoundGenerated"));
        setEvent({
          ...event,
          currentRound: getCurrentRound(event) + 1
        });

        changeRound(roundNo + 1);
      } else {
        await postData(`/events/${event.id}/generatePairings`);
        await handlePairingStatus("pending_generate", 5);
      }
    } catch (err) {
      postNotification("error", err);
    }
  };

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container sx={{ gap: 2 }}>
        <Grid
          item
          xs={12}
          sx={{
            p: 2
          }}
        >
          <Grid container sx={{ mb: 1 }}>
            <Grid
              item
              sx={{
                flex: 1
              }}
            >
              <Typography>
                {t("round")} {_roundNo}
              </Typography>
            </Grid>

            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {useWebSockets && socketStatus && (
                <WebSocketIndicator
                  status={socketStatus}
                  onClick={async () => {
                    if (socketStatus === "Disconnected" && roundNo) {
                      try {
                        setLoading(true);
                        await handlePairings(roundNo);
                        await handleWSConnection(roundNo);
                      } catch (err) {
                        postNotification("error", err);
                      } finally {
                        setLoading(false);
                      }
                    }
                  }}
                />
              )}

              <IconButton
                aria-label={t("previous")}
                disabled={Boolean(!_roundNo || _roundNo === 1)}
                sx={{ mr: 1 }}
                onClick={(e) => {
                  if (!subLoading) {
                    setSubLoading(true);
                  }
                  handleClick("dec");
                }}
              >
                <BCPAngleLeft />
              </IconButton>
              <IconButton
                aria-label={t("next")}
                disabled={Boolean(
                  !_roundNo || _roundNo === getCurrentRound(event)
                )}
                onClick={(e) => {
                  if (!subLoading) {
                    setSubLoading(true);
                  }
                  handleClick("inc");
                }}
              >
                <BCPAngleRight />
              </IconButton>
            </Grid>
          </Grid>

          {roundNo === getCurrentRound(event) && (
            <Grid container sx={{ mb: 1 }}>
              <Grid item xs sx={{ textAlign: "center" }}>
                <CountdownTimer
                  event={event}
                  roundNo={roundNo}
                  organize={organize}
                  timerData={timerData}
                  setTimerData={setTimerData}
                  setLoading={setLoading}
                  loading={loading}
                  hours
                  minutes
                  seconds
                  mapFunction={mapFunction}
                  displayMode={timerDisplayMode}
                  timerModalTrigger={timerModalTrigger}
                  setTimerModalTrigger={setTimerModalTrigger}
                  pairings={
                    useWebSockets
                      ? subLoading
                        ? null
                        : filteredPairings
                          ? filteredPairings
                          : pairings
                      : subLoading
                        ? null
                        : filteredPairings
                          ? filteredPairings
                          : event?.boardGameEvent ||
                              event?.format?.boardGameEvent
                            ? seatedPairings || []
                            : event?.teamEvent || event?.format?.teamEvent
                              ? teamPairings
                              : pairings
                  }
                />
              </Grid>
              {organize && (
                <Grid item>
                  <TimerDisplaySelector
                    displayMode={timerDisplayMode}
                    setDisplayMode={setTimerDisplayMode}
                    disabled={loading || subLoading}
                    timerData={timerData}
                    event={event}
                    setRoundTimerOptions={setRoundTimerOptions}
                    onModalOpen={() => setTimerModalTrigger((prev) => prev + 1)}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <EventPairingsOverview
                  event={event}
                  roundNo={roundNo}
                  organize={organize}
                  timerData={timerData}
                  setTimerData={setTimerData}
                  setLoading={setLoading}
                  loading={loading}
                  hours
                  minutes
                  seconds
                />
              </Grid>
              {!placingsReady && (
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                  <Typography variant="caption">
                    {t("placingsCurrentlyBeingUpdated")}
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
          {!organize &&
          !loading &&
          !subLoading &&
          !(
            useWebSockets
              ? pairings
              : event?.boardGameEvent || event?.format?.boardGameEvent
                ? seatedPairings || []
                : event?.teamEvent || event?.format?.teamEvent
                  ? teamPairings
                  : pairings
          )?.length ? (
            <Box sx={{ mb: 1 }}>
              <Alert color="info" variant="outlined" icon={false}>
                {t("noActivePairings")}
              </Alert>
            </Box>
          ) : (
            <></>
          )}
          <ListResponsive
            originalList={
              useWebSockets
                ? subLoading
                  ? null
                  : filteredPairings
                    ? filteredPairings
                    : pairings
                : subLoading
                  ? null
                  : filteredPairings
                    ? filteredPairings
                    : event?.boardGameEvent || event?.format?.boardGameEvent
                      ? seatedPairings || []
                      : event?.teamEvent || event?.format?.teamEvent
                        ? teamPairings
                        : pairings
            }
            doSearch
            doPages
            rowsPerPageArray={[
              16,
              32,
              48,
              64,
              96,
              { label: t("all"), value: -1 }
            ]}
            initialRowsPerPage={32}
            userRowsPerPage="pairings"
            authContext={authContext}
            actionButton={
              organize
                ? roundNo === getCurrentRound(event)
                  ? [
                      {
                        props: {
                          variant: "contained",
                          color: "primary",
                          disabled: subLoading,
                          // || !placingsReady,
                          onClick: async (e) => {
                            if (event.status?.ended) {
                              handleTabChange(null, tabIndexes.placings, event);
                              return;
                            }

                            if (event?.flags?.requirePairingPublish) {
                              let unpublished = [];
                              if (teamPairings?.length) {
                                unpublished = teamPairings.filter(
                                  (el) => !el?.published && !el?.isPod
                                );
                              } else if (pairings?.length) {
                                unpublished = pairings.filter(
                                  (el) => !el?.published && !el?.isPod
                                );
                              } else if (seatedPairings?.length) {
                                unpublished = seatedPairings.filter(
                                  (el) => !el?.published && !el?.isPod
                                );
                              }
                              if (unpublished?.length) {
                                setLoading(true);
                                try {
                                  await postData(
                                    `/events/${event.id}/publishPairings`,
                                    {
                                      body: {
                                        round: roundNo
                                      }
                                    }
                                  );
                                  setRefreshPairings(true);
                                } catch (err) {
                                  postNotification("error", err);
                                }
                                setLoading(false);
                                return;
                              }
                            }

                            if (pairings?.length > 0) {
                              let unsubmitted = pairings.filter(function (el) {
                                return !el?.isDone && !el?.isPod;
                              });
                              if (unsubmitted && unsubmitted?.length > 0) {
                                postNotification(
                                  "error",
                                  t("mustScoreAllPairings")
                                );
                                return;
                              }
                            }
                            if (teamPairings?.length) {
                              let unsubmitted = teamPairings.filter(
                                function (el) {
                                  return !el?.isDone && !el?.isPod;
                                }
                              );
                              if (unsubmitted && unsubmitted?.length > 0) {
                                postNotification(
                                  "error",
                                  t("mustScoreAllPairings")
                                );
                                return;
                              }
                            }
                            if (seatedPairings?.length > 0) {
                              let unsubmitted = seatedPairings.filter(
                                function (el) {
                                  return !el?.isDone && !el?.isPod;
                                }
                              );
                              if (unsubmitted && unsubmitted?.length > 0) {
                                postNotification(
                                  "error",
                                  t("mustScoreAllPairings")
                                );
                                return;
                              }
                            }

                            if (setRoundUpdating) setRoundUpdating(true);

                            if (
                              roundNo > 0 &&
                              event.rounds?.[roundNo]?.status !== "finalized"
                            ) {
                              setLoading(true);
                              try {
                                let updatedEvent = await postData(
                                  `/events/${event.id}/finalizeRound`,
                                  {
                                    body: {
                                      round: roundNo
                                    }
                                  }
                                );

                                if (
                                  roundNo >= updatedEvent.status?.numberOfRounds
                                ) {
                                  setEvent({ ...event, ...updatedEvent });
                                  setEndEventModal(true);
                                } else {
                                  setEvent({ ...event, ...updatedEvent });
                                }
                              } catch (err) {
                                postNotification("error", err);
                              }
                              setLoading(false);
                            } else if (
                              roundNo > 0 &&
                              roundNo >= event.status?.numberOfRounds
                            ) {
                              setEndEventModal(true);
                            } else {
                              if (
                                !Boolean(betweenRoundsModal) &&
                                (roundNo === 0 ||
                                  event.rounds?.[roundNo]?.status ===
                                    "finalized")
                              ) {
                                setBetweenRoundsModal(true);
                              } else {
                                generatePairings();
                              }
                            }
                          }
                          // startIcon: !placingsReady ? (
                          //   <CircularProgress size="1rem" />
                          // ) : (
                          //   <></>
                          // )
                        },
                        label: event.status?.ended
                          ? t("tournamentResults")
                          : roundNo === 0
                            ? `${t("start")} ${
                                event?.format?.leagueEvent
                                  ? t("league")
                                  : t("tournament")
                              }`
                            : roundNo === getCurrentRound(event) &&
                                event?.flags?.requirePairingPublish &&
                                (teamPairings?.length
                                  ? teamPairings
                                  : pairings
                                )?.filter((el) => !el?.published && el?.id)
                                  ?.length
                              ? t("publishPairings")
                              : roundNo === getCurrentRound(event) &&
                                  event.rounds?.[roundNo]?.status !==
                                    "finalized"
                                ? t("finalizeRound")
                                : roundNo === event.status?.numberOfRounds
                                  ? `${t("end")} ${event?.format?.leagueEvent ? t("league") : t("tournament")}`
                                  : t("nextRound")
                      },
                      {
                        props: {
                          variant: "outlined",
                          color: "primary",
                          "aria-expanded": Boolean(optionsAnchorEl)
                            ? true
                            : undefined,
                          onClick: (e) => {
                            setOptionsAnchorEl(e.currentTarget);
                          },
                          startIcon: <BCPAngleDown />
                        },
                        label: t("options")
                      },
                      {
                        props: {
                          variant: "contained",
                          color: "primary",
                          "aria-expanded": Boolean(optionsAnchorEl)
                            ? true
                            : undefined,
                          onClick: (e) => {
                            setFiltersAnchorEl(e.currentTarget);
                          },
                          disabled:
                            !pairings?.length &&
                            !teamPairings?.length &&
                            !seatedPairings?.length,
                          endIcon: filteredPairings ? (
                            <BCPFilter
                              sx={{ fontSize: "20px", width: "20px" }}
                            />
                          ) : (
                            <BCPFilterSlash
                              sx={{ fontSize: "24px", width: "24px" }}
                            />
                          )
                        },
                        label: t("filters")
                      }
                    ]
                  : [
                      {
                        props: {
                          variant: "outlined",
                          color: "primary",
                          fullWidth: true,
                          "aria-expanded": Boolean(optionsAnchorEl)
                            ? true
                            : undefined,
                          onClick: (e) => {
                            setOptionsAnchorEl(e.currentTarget);
                          },
                          startIcon: <BCPAngleDown />
                        },
                        label: t("options")
                      },
                      {
                        props: {
                          variant: "contained",
                          color: "primary",
                          "aria-expanded": Boolean(optionsAnchorEl)
                            ? true
                            : undefined,
                          onClick: (e) => {
                            setFiltersAnchorEl(e.currentTarget);
                          },
                          disabled:
                            !pairings?.length &&
                            !teamPairings?.length &&
                            !seatedPairings?.length,
                          endIcon: filteredPairings ? (
                            <BCPFilter
                              sx={{ fontSize: "20px", width: "20px" }}
                            />
                          ) : (
                            <BCPFilterSlash
                              sx={{ fontSize: "24px", width: "24px" }}
                            />
                          )
                        },
                        label: t("filters")
                      }
                    ]
                : event?.format?.leagueEvent &&
                    event?.player &&
                    getCurrentRound(event) > 0 &&
                    getCurrentRound(event) === roundNo
                  ? {
                      props: {
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        onClick: (e) => {
                          setCreatePairingModal(true);
                        },
                        disabled: subLoading
                      },
                      label: t("createPairing")
                    }
                  : null
            }
            searchProps={{
              label: t("searchPairings"),
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  if (useWebSockets) {
                    let filteredList = originalList.filter(function (el) {
                      if (el?.table?.toString().includes(searchText))
                        return true;

                      if (
                        el?.player1?.user?.firstName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player1?.firstName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player1?.user?.lastName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player1?.lastName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player2?.user?.firstName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player2?.firstName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player2?.user?.lastName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player2?.lastName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;

                      if (el?.teamPlayer1 || el?.teamPlayer2) {
                        if (
                          el?.teamPlayer1?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.teamPlayer2?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;

                        if (event?.format?.doublesEvent) {
                          let found = false;

                          el?.teamPlayer1?.players?.forEach((player) => {
                            if (
                              player?.name?.toLowerCase().includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }
                          });

                          el?.teamPlayer2?.players?.forEach((player) => {
                            if (
                              player?.name?.toLowerCase().includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }
                          });

                          return found;
                        }

                        if (
                          el.pairings?.length &&
                          el.pairings.filter((child) => {
                            if (
                              child?.player1?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player1?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player1?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player1?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player2?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player2?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player2?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player2?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;

                            return false;
                          })?.length
                        ) {
                          return true;
                        }
                      }

                      if (
                        el.seatedPlayers?.length &&
                        el.seatedPlayers.filter((child) => {
                          if (
                            child?.playerName
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;

                          if (
                            child?.teamName?.toLowerCase().includes(searchText)
                          )
                            return true;

                          if (
                            child?.team?.name
                              ?.toLowerCase()
                              .includes(searchText)
                          )
                            return true;

                          return false;
                        })?.length
                      ) {
                        return true;
                      }
                      return false;
                    });
                    return filteredList;
                  } else if (event?.format?.boardGameEvent) {
                    let filteredList = originalList.filter((pod) => {
                      if (pod?.table?.toString().includes(searchText))
                        return true;

                      let found = false;

                      pod?.seatedPlayers?.forEach((player) => {
                        if (
                          player?.searchString
                            ?.toString()
                            .includes(searchText) ||
                          player?.playerName?.toString().includes(searchText) ||
                          player?.teamName
                            ?.toLowerCase()
                            .includes(searchText) ||
                          player?.team?.name?.toLowerCase().includes(searchText)
                        ) {
                          found = true;
                        }
                      });

                      return found;
                    });

                    return filteredList;
                  } else {
                    let filteredList = originalList.filter(function (el) {
                      if (el?.table?.toString().includes(searchText))
                        return true;

                      if (
                        el?.player1?.firstName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player1?.user?.firstName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player1?.lastName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player1?.user?.lastName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player2?.firstName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player2?.user?.firstName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;
                      if (
                        el?.player2?.lastName
                          ?.toLowerCase()
                          .includes(searchText) ||
                        el?.player2?.user?.lastName
                          ?.toLowerCase()
                          .includes(searchText)
                      )
                        return true;

                      let extendedGroupName1 =
                        el?.player1?.groupID && el?.player1?.groupName
                          ? `Group ${
                              el?.player1?.groupID < 10
                                ? `0${el?.player1?.groupID}`
                                : el?.player1?.groupID
                            }: ${el?.player1?.groupName}`
                          : undefined;
                      let extendedGroupName2 =
                        el?.player2?.groupID && el?.player2?.groupName
                          ? `Group ${
                              el?.player2?.groupID < 10
                                ? `0${el?.player2?.groupID}`
                                : el?.player2?.groupID
                            }: ${el?.player2?.groupName}`
                          : undefined;

                      if (
                        extendedGroupName1
                          ?.toLowerCase()
                          ?.includes(searchText) ||
                        extendedGroupName2?.toLowerCase()?.includes(searchText)
                      )
                        return true;

                      if (el?.teamPlayer1 || el?.teamPlayer2) {
                        if (event?.format?.doublesEvent) {
                          let found = false;

                          el?.teamPlayer1?.players?.forEach((player) => {
                            if (
                              player?.name?.toLowerCase().includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }
                          });

                          el?.teamPlayer2?.players?.forEach((player) => {
                            if (
                              player?.name?.toLowerCase().includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }

                            if (
                              player?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              player?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            ) {
                              found = true;
                            }
                          });

                          return found;
                        }

                        if (
                          el?.teamPlayer1?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.teamPlayer2?.name
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;

                        if (
                          el.pairings?.length &&
                          el.pairings.filter((child) => {
                            if (
                              child?.player1?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player1?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player1?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player1?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player2?.firstName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player2?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              child?.player2?.lastName
                                ?.toLowerCase()
                                .includes(searchText) ||
                              child?.player2?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;

                            return false;
                          })?.length
                        ) {
                          return true;
                        }

                        if (
                          el.seatedPlayers?.length &&
                          el.seatedPlayers.filter((child) => {
                            if (
                              child?.playerName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;

                            return false;
                          })?.length
                        ) {
                          return true;
                        }
                      }

                      return false;
                    });
                    return filteredList;
                  }
                }
              }
            }}
            rowProps={{
              headings: (
                <Grid item xs={12}>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    {t("table")}
                  </Typography>
                </Grid>
              ),
              mapFunction: (row, index) => {
                if (!organize && event?.adepticonTeamEvent) {
                  return (
                    <AdepticonTeamRow
                      organize={organize}
                      row={row}
                      setTeamPairing={setTeamPairing}
                      setTeamPlayer={setTeamPlayer}
                      setPairing={setPairing}
                      setPairingPopUp={setPairingPopUp}
                      setPlayer={setPlayer}
                      setOptionsAnchorEl2={setOptionsAnchorEl2}
                      setOptionsAnchorEl5={setOptionsAnchorEl5}
                      event={event}
                      authContext={authContext}
                      postSoftScoreSubmit={postSoftScoreSubmit}
                    />
                  );
                } else if (
                  row?.pairingType === "SeatedPairing" ||
                  row?.pairingType === "BCPSeatedPairing"
                ) {
                  return (
                    <SeatedRow
                      organize={organize}
                      row={row}
                      setPairing={setSeatedPairing}
                      setPairingPopUp={setPairingPopUp}
                      setPlayer={setPlayer}
                      setOptionsAnchorEl6={setOptionsAnchorEl6}
                      postSoftScoreSubmit={postSoftScoreSubmit}
                    />
                  );
                } else if (event?.format?.doublesEvent) {
                  return (
                    <DoublesRow
                      organize={organize}
                      row={row}
                      event={event}
                      setTeamPairing={setTeamPairing}
                      setTeamPlayer={setTeamPlayer}
                      setPairingPopUp={setPairingPopUp}
                      setOptionsAnchorEl5={setOptionsAnchorEl5}
                      postSoftScoreSubmit={postSoftScoreSubmit}
                    />
                  );
                } else if (event?.format?.teamEvent) {
                  return (
                    <TeamRow
                      organize={organize}
                      row={row}
                      setTeamPairing={setTeamPairing}
                      setTeamPlayer={setTeamPlayer}
                      setPairing={setPairing}
                      setPairingPopUp={setPairingPopUp}
                      setPlayer={setPlayer}
                      setOptionsAnchorEl2={setOptionsAnchorEl2}
                      setOptionsAnchorEl5={setOptionsAnchorEl5}
                      event={event}
                      postSoftScoreSubmit={postSoftScoreSubmit}
                    />
                  );
                } else {
                  return (
                    <PlayerRow
                      organize={organize}
                      row={row}
                      setPairing={setPairing}
                      setPairingPopUp={setPairingPopUp}
                      setPlayer={setPlayer}
                      setOptionsAnchorEl2={setOptionsAnchorEl2}
                      event={event}
                      postSoftScoreSubmit={postSoftScoreSubmit}
                      key={index}
                    />
                  );
                }
              }
            }}
          />
        </Grid>
      </Grid>

      <PairingModal
        pairing={pairingPopUp}
        setPairing={setPairingPopUp}
        event={event}
        setOptionsAnchorEl4={setOptionsAnchorEl4}
        setLoading={setLoading}
        setRefreshPairings={setRefreshPairings}
        authContext={authContext}
        setSwapTableModal={setSwapTableModal}
      />
      {organize && (
        <>
          <OptionsMenu
            anchorEl={optionsAnchorEl}
            setAnchorEl={setOptionsAnchorEl}
            event={event}
            roundNo={roundNo}
            setEvent={setEvent}
            setRoundTimerOptions={setRoundTimerOptions}
            setTopCutOptions={setTopCutOptions}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
            authContext={authContext}
            handleTabChange={handleTabChange}
            setResetModalOpen={setResetModalOpen}
            setCreatePairingModal={setCreatePairingModal}
          />

          <FiltersMenu
            anchorEl={filtersAnchorEl}
            setAnchorEl={setFiltersAnchorEl}
            event={event}
            filterType={filterType}
            setFilterType={setFilterType}
          />

          <PairingOptionsMenu
            event={event}
            anchorEl={optionsAnchorEl2}
            setAnchorEl={setOptionsAnchorEl2}
            pairing={pairing}
            setPairing={setPairing}
            player={player}
            setArmyModalOpen={setArmyModalOpen}
            setSwapPlayerModal={setSwapPlayerModal}
            setRefreshPairings={setRefreshPairings}
          />

          <TeamPairingOptionsMenu
            event={event}
            anchorEl={optionsAnchorEl5}
            setAnchorEl={setOptionsAnchorEl5}
            teamPairing={teamPairing}
            setTeamPairing={setTeamPairing}
            teamPlayer={teamPlayer}
            setSwapTeamModal={setSwapTeamModal}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
          />
          <SeatedPairingOptionsMenu
            event={event}
            anchorEl={optionsAnchorEl6}
            setAnchorEl={setOptionsAnchorEl6}
            seatedPairing={seatedPairing}
            setSeatedPairing={setSeatedPairing}
            player={player}
            setSwapSeatedPairingModal={setSwapSeatedPairingModal}
            setSwapSeatNumberModal={setSwapSeatNumberModal}
          />
          <PairingPopUpOptionsMenu
            anchorEl={optionsAnchorEl4}
            setAnchorEl={setOptionsAnchorEl4}
            pairing={pairingPopUp}
            setPairing={setPairingPopUp}
            event={event}
            authContext={authContext}
            setLoading={setLoading}
            setRefreshPairings={setRefreshPairings}
            setSwapTableModal={setSwapTableModal}
          />

          <RoundTimerModal
            event={roundTimerOptions}
            setEvent={setRoundTimerOptions}
            onSave={async (values) => {
              var newTimer = {};
              if (!values) return;
              if (values.timerData) {
                newTimer.timerLength =
                  parseInt(values.timerData.hrs) * 60 * 60 +
                  parseInt(values.timerData.mins) * 60;
                newTimer.startTime = event?.location?.timezone
                  ? moment
                      .tz(moment().format(), event.location.timezone)
                      .utc()
                      .format()
                  : moment().utc().format();
                newTimer.endTime = event?.location?.timezone
                  ? moment
                      .tz(
                        moment().add(newTimer.timerLength, "seconds"),
                        event.location.timezone
                      )
                      .utc()
                      .format()
                  : moment()
                      .add(newTimer.timerLength, "seconds")
                      .utc()
                      .format();
              }
              if (values.startTime && values.endTime && !values.timerLength) {
                newTimer.timerLength = moment(
                  values.endTime,
                  "YYYY-MM-DDTHH:mm"
                ).diff(moment(values.startTime, "YYYY-MM-DDTHH:mm"), "seconds");
                newTimer.startTime = event?.location?.timezone
                  ? moment
                      .tz(
                        moment(values.startTime, "YYYY-MM-DDTHH:mm")
                          .utc()
                          .format(),
                        event.location.timezone
                      )
                      .utc()
                      .format()
                  : moment(values.startTime, "YYYY-MM-DDTHH:mm").utc().format();
                newTimer.endTime = event?.location?.timezone
                  ? moment
                      .tz(
                        moment(values.endTime, "YYYY-MM-DDTHH:mm"),
                        event.location.timezone
                      )
                      .utc()
                      .format()
                  : moment(values.endTime, "YYYY-MM-DDTHH:mm").utc().format();
              }
              var roundTimers = {
                ...event?.roundTimers,
                [roundNo]: newTimer
              };
              try {
                setLoading(true);
                await postData(`/events/${event.id}`, {
                  body: {
                    set: {
                      roundTimers: roundTimers
                    }
                  }
                });
                setTimerData(newTimer);
                setRoundTimerOptions(null);
              } catch (err) {
                postNotification("error", err);
              }
              setLoading(false);
              return;
            }}
          />
          <TopCutModal
            open={topCutOptions}
            setOpen={setTopCutOptions}
            event={event}
            setEvent={setEvent}
            setLoading={setLoading}
            changeRound={changeRound}
            setRoundUpdating={setRoundUpdating}
            setTriggerHandlePairingStatus={setTriggerHandlePairingStatus}
          />

          <EndEventModal
            open={endEventModal}
            setOpen={setEndEventModal}
            setTopCutOptions={setTopCutOptions}
            event={event}
            setEvent={setEvent}
            setLoading={setLoading}
            handleTabChange={handleTabChange}
            changeRound={changeRound}
            setRoundUpdating={setRoundUpdating}
            authContext={authContext}
          />
          {player && armyModalOpen && (
            <ArmyListComponent
              modal
              event={event}
              open={armyModalOpen}
              setOpen={setArmyModalOpen}
              player={player}
              setPlayer={setPlayer}
              organize={true}
              active
              tArmyList={tArmyList}
            />
          )}
          {swapPlayerModal && (
            <SwapPlayersModal
              open={swapPlayerModal}
              setOpen={setSwapPlayerModal}
              pairings={pairings}
              pairing={pairing}
              player={player}
              players={players}
              setRefreshPairings={setRefreshPairings}
              loading={loading}
              setLoading={setLoading}
            />
          )}

          <SwapTeamPlayersModal
            open={swapTeamModal}
            setOpen={setSwapTeamModal}
            teamPairing={teamPairing}
            setTeamPairing={setTeamPairing}
            teamPlayer={teamPlayer}
            teamPlayers={teamPlayers}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
            event={event}
          />
          <SwapSeatNumberModal
            open={swapSeatNumberModal}
            setOpen={setSwapSeatNumberModal}
            pairing={seatedPairing}
            setPairing={setSeatedPairing}
            player={player}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
          />
          <SwapSeatedTableModal
            open={swapSeatedPairingModal}
            setOpen={setSwapSeatedPairingModal}
            pairing={seatedPairing}
            setPairing={setSeatedPairing}
            player={player}
            pairings={useWebSockets ? pairings : seatedPairings}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
          />
          <SwapTableModal
            pairing={pairingPopUp}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
            open={swapTableModal}
            setOpen={setSwapTableModal}
            setPairing={setPairingPopUp}
          />

          <ProgressModal
            open={pairingProgress > 0 && pairingStatus}
            value={pairingProgress}
          />

          {betweenRoundsModal && (
            <BetweenRoundsModal
              open={betweenRoundsModal}
              setOpen={setBetweenRoundsModal}
              event={event}
              setEvent={setEvent}
              setLoading={setLoading}
              generatePairings={generatePairings}
              isStart={roundNo === 0}
            />
          )}
        </>
      )}

      {event?.format?.leagueEvent && (
        <>
          <CreatePairingModal
            organize={organize}
            round={roundNo}
            event={event}
            open={createPairingModal}
            setOpen={setCreatePairingModal}
            player={event.player}
            players={players}
            pairings={pairings}
            seatedPairings={seatedPairings}
            setRefreshPairings={setRefreshPairings}
            setLoading={setLoading}
          />
        </>
      )}

      {loading && <ModalLoadingFull />}
    </Container>
  );
}
